import React, { useMemo, useState } from 'react';
import { toast } from 'sonner';
import { createCashfreeOrder } from '../api/insights';

const SDK_URL = 'https://sdk.cashfree.com/js/v3/cashfree.js';

function loadCashfreeScript() {
  return new Promise((resolve, reject) => {
    if (window.Cashfree) {
      resolve(true);
      return;
    }
    const existing = document.querySelector('script[data-cashfree-sdk="1"]');
    if (existing) {
      existing.addEventListener('load', () => resolve(true), { once: true });
      existing.addEventListener('error', () => reject(new Error('Failed to load Cashfree SDK')), { once: true });
      return;
    }
    const script = document.createElement('script');
    script.src = SDK_URL;
    script.async = true;
    script.setAttribute('data-cashfree-sdk', '1');
    script.onload = () => resolve(true);
    script.onerror = () => reject(new Error('Failed to load Cashfree SDK'));
    document.body.appendChild(script);
  });
}

export default function CashfreeCheckoutButton({
  amountRupees = 349,
  buttonLabel = 'Unlock Premium ₹349',
  className = '',
  style = {},
  disabled = false,
}) {
  const [processing, setProcessing] = useState(false);
  const mode = useMemo(() => (process.env.REACT_APP_CASHFREE_MODE || 'sandbox').toLowerCase(), []);

  const handleCheckout = async () => {
    setProcessing(true);
    try {
      await loadCashfreeScript();
      const order = await createCashfreeOrder({ amount: amountRupees, currency: 'INR' });
      if (!order?.payment_session_id) {
        throw new Error('Payment session missing from backend');
      }

      const cashfree = window.Cashfree({ mode });
      cashfree.checkout({
        paymentSessionId: order.payment_session_id,
        redirectTarget: '_self',
      });
    } catch (err) {
      toast.error(err.message || 'Unable to start Cashfree checkout');
      setProcessing(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleCheckout}
      disabled={processing || disabled}
      className={`px-4 py-2 rounded-lg font-semibold disabled:opacity-60 transition-all ${className}`}
      style={{
        background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
        color: '#ffffff',
        border: '1px solid rgba(37,99,235,0.35)',
        fontSize: 16,
        lineHeight: 1.2,
        ...style,
      }}
    >
      {processing ? 'Redirecting...' : buttonLabel}
    </button>
  );
}
